// Tree expansion state (Phase 3b) — PURE reducer. Tracks which node paths are
// expanded (a Set of stable path keys). The children themselves are cached by
// React Query per scoped fetch; this reducer only owns the expand/collapse set,
// which a filter/date change RESETS (collapse to the top level) so stale children
// can't linger under a changed filter.

export type ExpansionState = ReadonlySet<string>;

export type ExpansionAction =
  | { type: 'toggle'; key: string }
  | { type: 'expand'; key: string }
  | { type: 'collapse'; key: string }
  | { type: 'reset' };

export const EMPTY_EXPANSION: ExpansionState = new Set();

export function expansionReducer(state: ExpansionState, action: ExpansionAction): ExpansionState {
  switch (action.type) {
    case 'reset':
      return state.size === 0 ? state : new Set();
    case 'expand': {
      if (state.has(action.key)) return state;
      const next = new Set(state);
      next.add(action.key);
      return next;
    }
    case 'collapse': {
      if (!state.has(action.key)) return state;
      const next = new Set(state);
      next.delete(action.key);
      return next;
    }
    case 'toggle': {
      const next = new Set(state);
      if (next.has(action.key)) next.delete(action.key);
      else next.add(action.key);
      return next;
    }
  }
}
